<div class="gc-connection" [ngClass]="{'dark-mode': darkMode===true}" (window:resize)="onResize($event)">
    <div class="heading">
        <div class="layout">
            <div class="logo" [ngStyle]="{ 'background-image': 'url('+serverRoot +'/app-client/resource/by-usage/'+tenant+'/display-logo)' }">
            </div>
            <div class="welcome">
                {{configurationService.getClientParamValue('display.gc-connection.welcome-message', 'Herzlich willkommen')}}
            </div>
        </div>
    </div>
    <div class="content">
        <div class="layout">
            <div class="qr-code-box">
                <qrcode class="qr-code" *ngIf="info.qrCodeUrl" [scale]="qrScale"
                    [colorDark]="darkMode?'#ffffff':'#000000'" [colorLight]="darkMode?'#000000':'#ffffff'"
                    [qrdata]="info.qrCodeUrl" [errorCorrectionLevel]="'M'"></qrcode>
            </div>
            <div class="labels">
                <!--div class="carrier">
                    {{info.carrier}}
                </div-->
                <div class="identifier">
                    {{info.identifier}}
                </div>
            </div>
        </div>
    </div>
</div>
